import PolicyLayout from './PolicyLayout';
import { COMPANY_NAME, POLICY_UPDATED, SITE_DOMAIN, SITE_NAME } from '../constants/site';

export default function Disclaimer() {
  return (
    <PolicyLayout
      title="Disclaimer"
      updated={POLICY_UPDATED}
      intro={`Please read this before relying on anything published on ${SITE_DOMAIN}.`}
    >
      <h2>We are independent</h2>
      <p>
        {COMPANY_NAME} operates {SITE_NAME} at {SITE_DOMAIN} as an independent accounting
        and technical support service. We are not affiliated with, endorsed by or acting as an
        agent of any accounting software publisher.
      </p>

      <h2>Trademarks</h2>
      <p>
        Product names, logos and brands mentioned on this site are used only to describe the
        categories of software we support. All trademarks belong to their respective owners.
        Their appearance does not imply endorsement.
      </p>

      <h2>Not professional advice</h2>
      <p>
        Content on this site is general information about software behaviour and bookkeeping
        practice. It is not legal, tax or regulated accounting advice, and it is not a
        substitute for guidance from your own qualified accountant on your specific
        circumstances.
      </p>

      <h2>Accuracy</h2>
      <p>
        Accounting software changes with each release. We keep these pages current as best we
        can, but we make no warranty that every description matches the exact version, edition
        or region you are running.
      </p>

      <h2>Third party links</h2>
      <p>
        Where we link to external publisher or vendor sites, we do not control that content and
        are not responsible for it.
      </p>

      <h2>Pricing</h2>
      <p>
        Licence prices shown are indicative and subject to change by the software publisher
        without notice. The price confirmed on your written quote is the one that applies to
        your order.
      </p>
    </PolicyLayout>
  );
}
